var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49688 5.29688C4.39063 5.29688 4.29427 5.27865 4.20781 5.24219C4.12136 5.20573 4.04167 5.15104 3.96875 5.07812L0.974032 2.08341C0.803845 1.91322 0.723959 1.72917 0.734376 1.53125C0.744793 1.33333 0.833334 1.15104 1 0.984375C1.16667 0.817708 1.34896 0.734375 1.54688 0.734375C1.74479 0.734375 1.92708 0.817708 2.09375 0.984375L4.5 3.42188L6.9375 0.984375C7.10417 0.817708 7.28646 0.739583 7.48438 0.75C7.68229 0.760417 7.86458 0.848958 8.03125 1.01562C8.19792 1.18229 8.28125 1.36458 8.28125 1.5625C8.28125 1.76042 8.19616 1.94418 8.02597 2.11378L5.03125 5.07812C4.95417 5.15104 4.8724 5.20573 4.78594 5.24219C4.69948 5.27865 4.60313 5.29688 4.49688 5.29688Z",
    fill: "#082A6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.24a66768db0bbd49cc9c44396ce3c16b.svg";
export { ForwardRef as ReactComponent };